// extracted by mini-css-extract-plugin
export default {"wrapper":"InfoBlock_wrapper__qoSqN","confirm":"InfoBlock_confirm__-Tiys"};